<template>
  <SuggestPart
      item-value="id"
      :item-text="(Item) => {
        return this.$moment(Item.paidAt).format('DD.MM.YYYY') + ' - ' + Item.title + ' (' + this.$options.filters.currency(Item.balance, '€') + ')'
      }"
      itemsKey="revenues"
      :fetchData="fetchData"
      v-bind="$attrs"
      v-on="$listeners"
  />
</template>

<script>
  import Revenues from '@/services/revenues'

  import SuggestPart from '@/components/_Part/Suggest'

  export default {
    name: 'SuggestOnlyAlertBalance',
    components: {
      SuggestPart
    },
    methods: {
      fetchData() {
        return Revenues
          .suggestOnlyAlertBalance()
      }
    }
  }
</script>
